export default __webpack_public_path__ + "static/media/programmer.32876dc6.png";